var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg",style:({'--color_fill': _vm.color}),attrs:{"width":`${_vm.width}px`,"height":`${_vm.width}px`}},[_vm._v(" > "),_c('use',{attrs:{"href":require("@/assets/images/svg/infobox.svg") + "#img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }